import styled, { css } from "styled-components";
import { Colors } from "../../../../../values/colors";

export const Container = styled.div`
  ${({ isVisible }) => !isVisible && css`
    display: none;
  `};
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 22px;
  background-color: ${(props) => props.isEnabled ? Colors.white : "#E7EBEF"};
  pointer-events: ${(props) => !props.isEnabled && "none"};
`;

export const ConfigTitle = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  color: ${Colors.blueGray2};
  font-size: 14px;
  font-weight: 600;
  line-height: 10.98px;
  width: 493px;
`;

export const InputColor = styled.input`
    width: 69px;
    height: 69px;
    background-color: ${(props) => props.isEnabled ? Colors.white : "#E7EBEF"};
`;

export const ColorContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    padding-right: 2rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
`;

export const DescriptionContainer = styled.div`
    margin-left: 10px;
    width: 40%;
`;

export const Description = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  color: ${Colors.blueMist};
  font-size: 13px;
  font-weight: 400;
  line-height: 20.48px;
  margin-bottom: 5px;
`;